const info = {
  ZH: { //中文翻译
    searchMds: "\u67E5\u8BE2MDS",
    search: "\u67E5\u627E",
    substanceInfo: "\u7269\u8D28\u4FE1\u606F",
    casNum: "CAS\u7F16\u53F7",
    gadsl: "GADSL\u5206\u7C7B",
    shenbao: "\u9700\u7533\u62A5",
    forbid: "\u88AB\u7981\u6B62",
    engName: "\u82F1\u6587\u540D\u79F0\:",
    alias1: "\u522B\u540D\:",
    alias2: "\u522B\u540D2\:",
    alias3: "\u522B\u540D3\:",
    return: "\u8FD4\u56DE",
    einecs: "EC\u7F16\u53F7",
  },
  EN: { //英文翻译
    searchMds: "Search MDS",
    search: "Search",
    substanceInfo: "Substance Einformation",
    casNum: "CAS No.",
    gadsl: "GADSL classification",
    shenbao: "duty-to-declare",
    forbid: "Prohibited",
    engName: "English name:",
    alias1: "Synonym\:",
    alias2: "Synonym2:",
    alias3: "Synonym3:",
    return: "Back",
    einecs: "EC-Index",
  }
}
export default info //需要暴露出去
